module.exports = __webpack_public_path__ + "img/icon_trade_contract_home.2d7067c0.svg";